import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { validateEditAddress } from "../../../constant/validation";
import { getUser, onlyMobile, onlyNumber } from "../../../constant/utils";
import { useDispatch, useSelector } from "react-redux";
import { profileAction } from "../../../redux/action";
import Select from "react-select";


interface IMember {
  open: boolean;
  editData: any;
  handleClose: () => void;
  handleSubmit: (data: any) => void;
}
const AddEditAddressChk = ({
  open,
  handleClose,
  handleSubmit,
  editData,
}: IMember) => {
  ReactModal.setAppElement("body");
  const dispatch = useDispatch();
  const USER = getUser();

  const [initialValue, setInitialValue] = useState<any>({
    AddressLine1: "",
    HouseNo: "",
    StateId: "",
    CityId: "",
    Pincode: "",
    AddressTag: "home",
    CustomerId:USER?.Id,
  });

  const commonLoading: any = useSelector((state: any) =>
    state.common.loader ? state.common.loader : false
  );
  const fullCityData = useSelector((state: any) => state.dashboard.city);
  const CityId = useSelector((state: any) => state.dashboard.selectedCity);
  const stateList: any[] = useSelector(
    (state: any) => state?.profile?.stateList || []
  );
  const crmStateList: any[] = useSelector(
    (state: any) => state?.profile?.crmStateList || []
  );
  const crmCityList: any[] = useSelector(
    (state: any) => state?.profile?.crmCityList || []
  );

  // console.log("crmCityList", crmCityList);
  const cityData: any[] = useSelector(
    (state: any) => state?.profile?.cityList || []
  );
  const pincodeData: any[] = useSelector(
    (state: any) => state?.profile?.pincodeList || []
  );
  useEffect(() => {
    let nData = CityId && fullCityData?.find((ele: any) => ele?.Id == CityId);
    if (editData?.id) {
      handleStateChange(editData?.state_id);
      handleCityChange(editData?.city_id);
      setInitialValue({
        AddressLine1: editData?.locality_name || "",
        HouseNo: editData?.house_no || "",
        StateId: editData?.state_id || "",
        CityId: editData?.city_id || "",
        Pincode: editData?.pincode || "",
        AddressTag: editData?.address_tag || "home",
      });
    } else {
      setInitialValue({
        StateId: nData?.StateId,
        CityId: nData?.Id,
        CustomerId:USER?.Id,
        AddressTag: editData?.address_tag || "home",
      });
      CityId && handleStateChange(nData?.StateId);
      CityId && handleCityChange(nData?.Id);
    }
  }, [editData]);

  // console.log("initialValue", initialValue);  

  function handleStateChange(StateId: any) {
    let id = getCrmState(StateId);
    dispatch(
      profileAction.cityListAction({ StateId: StateId, CrmStateId: id })
    );
  }
  function handleCityChange(CityId: any) {
    dispatch(profileAction.pincodeListAction({ CityId }));
  }
  function getCrmState(id: any) {
    let _stateName = stateList?.find(
      (ele: any) => ele?.StateId == id
    )?.StateName;
    let _stateId = crmStateList?.find(
      (ele: any) => ele?.title?.toLowerCase() == _stateName?.toLowerCase()
    )?.tag;
    return _stateId;
  }
  function getCrmCity(id: any) {
    const normalizeCityName = (name: string) => {
  if (!name) return "";

  switch (name.toLowerCase()) {
    case "gurgaon":
    case "gurugram":
      return "gurgaon"; // use one canonical name
    default:
      return name.toLowerCase();
  }
};
    let _cityName = cityData?.find((ele: any) => ele?.CityId == id)?.CityName;
    // let _cityId = crmCityList?.find(
    //   (ele: any) => ele?.title?.toLowerCase() == _cityName?.toLowerCase()
    // )?.tag;
    let _cityId = crmCityList?.find(
  (ele: any) => normalizeCityName(ele?.title) === normalizeCityName(_cityName)
)?.tag;
      // console.log("cityid", _cityId,"and",_cityName);
    return _cityId;
  }
  let newCityData = cityData?.map((ele) => ({
    label: ele?.CityName,
    value: ele?.CityId,
  }));
  let newPincodeData = pincodeData?.map((ele) => ({
    label: ele?.pincode,
    value: ele?.pincode,
  }));
  return (
    <ReactModal
      isOpen={open}
      /* style={customStyles} */
      onRequestClose={handleClose}
      className="my_acc_modal"
      overlayClassName="my_acc_overlay"
    >
      <div className="cross_button">
        <img
          src="/assets/img/my-profile/cross.png"
          alt=""
          className="cursor-pointer"
          onClick={handleClose}
        />
        <div className="acc_modal_content">
          <h6 className="pb-3">
            {editData?.id ? "Edit Address" : "Add New Address"}
          </h6>
          <div>
            <Formik
              initialValues={initialValue}
              enableReinitialize={true}
              validationSchema={validateEditAddress}
              onSubmit={(val: any) => {
                let CrmStateId =
                  getCrmState(val?.StateId) || editData?.CrmStateId || "";
                let CrmCityId =
                  getCrmCity(val?.CityId) || editData?.CrmCityId || "";
                handleSubmit({ ...val, CrmStateId, CrmCityId });
                console.log("crm",CrmCityId)
              }}
              render={({
                setFieldValue,
                values,
                handleChange,
                errors,
                touched,
                handleBlur,
                handleSubmit,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row align-items-start">
                    {/* <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">
                          Select Address Tag*
                        </label>
                        <select
                          name="AddressTag"
                          className="form-control profileInp"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.AddressTag}
                        >
                          <option value=""> Select Address Tag</option>
                          <option value="home">Home</option>
                          <option value="work">Work</option>
                          <option value="others">Others</option>
                        </select>
                        {touched?.AddressTag && errors?.AddressTag && (
                          <span className="error_message">
                            {errors?.AddressTag}
                          </span>
                        )}
                      </div>
                    </div> */}
                    <div className="col-12">
                      <div className="form-group">
                        <label className="profileLabel">
                          Colony/Area/Sector*
                        </label>
                        <input
                          type="text"
                          name="AddressLine1"
                          className="form-control profileInp"
                          placeholder="Enter Colony/Area/Sector"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.AddressLine1}
                        />
                        {touched?.AddressLine1 && errors?.AddressLine1 && (
                          <span className="error_message">
                            {errors?.AddressLine1}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">
                          House No./Building/Flat*
                        </label>
                        <input
                          type="text"
                          name="HouseNo"
                          className="form-control profileInp"
                          placeholder="Enter House No."
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.HouseNo}
                        />
                        {touched?.HouseNo && errors?.HouseNo && (
                          <span className="error_message">
                            {errors?.HouseNo}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Pincode*</label>
                        {/* <input
                          type="text"
                          name="Pincode"
                          className="form-control profileInp"
                          placeholder="Enter Pincode"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.Pincode}
                          maxLength={6}
                          onKeyPress={onlyNumber}
                        /> */}
                        {/* <Select
                          options={newPincodeData}
                          onChange={(data: any) =>{
                            console.log(data?.value,data);
                            setFieldValue("Pincode", data?.value);
                          }}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPlacement="auto"
                          components={{
                            IndicatorSeparator: () => null,
                          }}
                          placeholder="Select Pincode"
                          value={
                            newPincodeData?.find(
                              (ele: any) => ele?.value == values?.Pincode
                            ) || null
                          }
                          
                        /> */}
                        <input
                          list="pin"
                          name="Pincode"
                          className="form-control profileInp"
                          placeholder="Enter Pincode"
                          value={values?.Pincode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onInput={onlyMobile}
                          maxLength={6}
                        />
                        <datalist id="pin">
                          {pincodeData?.map((ele: any) => (
                            <option value={ele?.pincode} />
                          ))}
                        </datalist>
                        {touched?.Pincode && errors?.Pincode && (
                          <span className="error_message">
                            {errors?.Pincode}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">City*</label>
                        {/* <select
                          name="CityId"
                          className="form-control profileInp"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.CityId}
                        >
                          <option value=""> Select city</option>
                          {cityData && cityData?.length > 0 && cityData?.map((item: any, i: any) => (
                                <option className="text-capitalize" value={item?.CityId} key={i}>{item?.CityName}</option>
                              ))}
                        </select> */}
                        <Select
                          isDisabled={true}
                          options={newCityData}
                          onChange={(data: any) => {
                            handleCityChange(data?.value);
                            setFieldValue("CityId", data?.value);
                            setFieldValue("Pincode", "");
                          }}
                          menuPlacement="auto"
                          components={{
                            IndicatorSeparator: () => null,
                          }}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          placeholder="Select City"
                          value={
                            newCityData?.find(
                              (ele: any) => ele?.value == values?.CityId
                            ) || null
                          }
                        />
                        {touched?.CityId && errors?.CityId && (
                          <span className="error_message">
                            {errors?.CityId}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">State*</label>
                        <select
                          disabled={true}
                          name="StateId"
                          className="form-control profileInp"
                          onChange={(e: any) => {
                            handleStateChange(e.target.value);
                            setFieldValue("CityId", "");
                            setFieldValue("Pincode", "");
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          value={values?.StateId}
                        >
                          <option value=""> Select State</option>
                          {stateList?.map((ele: any, i: any) => {
                            return (
                              <option value={ele?.StateId}>
                                {" "}
                                {ele?.StateName}
                              </option>
                            );
                          })}
                        </select>
                        {touched?.StateId && errors?.StateId && (
                          <span className="error_message">
                            {errors?.StateId}
                          </span>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-12">
                      <div className="form-group">
                        <div>
                          <div className="form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Default"
                              id="flexRadioDefault1"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value="true"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              Make Defaut Address
                            </label>
                          </div>
                        </div>
                        {touched?.Default && errors?.Default && (
                          <span className="error_message">
                            {errors?.Default}
                          </span>
                        )}
                      </div>
                    </div> */}
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="book--hexagon active sm_form"
                        disabled={commonLoading}
                      >
                        <span>
                          {commonLoading
                            ? "Loading..."
                            : editData?.id
                            ? "Update"
                            : "Save"}
                          <i
                            className="fa fa-long-arrow-right ml-20"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </div>
                    {!editData?.id && (
                      <div
                        className="col-12"
                        style={{
                          color: "red",
                          fontWeight: "500",
                          marginTop: "-10px",
                        }}
                      >
                        *You are booking for{" "}
                        {
                          fullCityData?.find((ele: any) => ele?.Id == CityId)
                            ?.Name
                        }
                        , if you want to add address for other city please
                        change city first from top navbar.
                      </div>
                    )}
                  </div>
                </form>
              )}
            />
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default AddEditAddressChk;
